<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.container"
  >
    <template v-if="coeditedTenantUserSkills.length === 0">
      <DataPlaceholderPrimary :style="style.placeholder">
        <template v-slot:bottom>
          There is no data to show.
        </template>
      </DataPlaceholderPrimary>
    </template>
    <template v-else>
      <div :style="style.innerContainer">
        <div :style="style.leftContainer">
          <div
            v-for="(tenantUserSkill, index) in coeditedTenantUserSkills"
            :key="index"
            :style="style.row"
          >
            <TagPrimary>
              {{ tenantUserSkill.skill.name }}
            </TagPrimary>
            <div :style="style.text">
              added by
            </div>
            <LinkNamePrimary
              v-if="tenantUserSkill.creater"
              :tenantUser="tenantUserSkill.creater"
              :style="style.linkName"
            />
            <div
              v-else
              :style="style.namePlaceholder"
            >
              deactivated user
            </div>
          </div>
        </div>
        <div :style="style.rightContainer">
          <div
            v-for="(tenantUserSkill, index) in coeditedTenantUserSkills"
            :key="`${index}_right`"
            :style="style.buttonContainer"
          >
            <template v-if="isCompleted(tenantUserSkill)">
              <TextMutedPrimary :style="style.textMuted">
                Completed
              </TextMutedPrimary>
            </template>
            <template v-else-if="isViewingOwnPage">
              <ButtonAction
                v-if="!isCompleted(tenantUserSkill)"
                @click="$emit('review-skill', tenantUserSkill)"
              >
                Review
              </ButtonAction>
            </template>
            <template v-else>
              <ButtonSecondary
                v-if="isRevokable(tenantUserSkill)"
                @click="$emit('revoke-skill', tenantUserSkill)"
              >
                Revoke
              </ButtonSecondary>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import ButtonAction from '@modules/v2/button/button-action'
  import ButtonSecondary from '@modules/v2/button/button-secondary'
  import DataPlaceholderPrimary from '@modules/v2/placeholder/data-placeholder-primary'
  import LinkNamePrimary from '@modules/v2/link/link-name-primary'
  import TagPrimary from '@modules/v2/tag/tag-primary'
  import TextMutedPrimary from '@modules/v2/text/text-muted-primary'
  import { FontStyle, Layout } from '@js/styles'
  import { getCoeditedTenantUserSkills } from '@js/skill-utils'

  export default {
    name: 'CoeditHistory',
    inheritAttrs: false,
    components: {
      ButtonAction,
      ButtonSecondary,
      DataPlaceholderPrimary,
      LinkNamePrimary,
      TagPrimary,
      TextMutedPrimary,
    },
    props: {
      isViewingOwnPage: {
        type: Boolean,
        required: false,
        default: false,
      },
      tenantUserSkills: {
        type: Array,
        required: false,
        default: () => [],
      },
      visitor: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        style: {
          buttonContainer: {
            alignItems: 'center',
            display: 'flex',
            height: '33px',
            justifyContent: 'flex-end',
            margin: `${Layout.space.sm} 0`,
          },
          container: {
            height: '100%',
            overflowX: 'auto',
            overflowY: 'scroll',
          },
          innerContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          },
          leftContainer: {
            margin: `0 ${Layout.space.sm} 0 0`,
            overflowX: 'scroll',
            width: '100%',
          },
          linkName: {
            whiteSpace: 'nowrap',
          },
          namePlaceholder: {
            whiteSpace: 'nowrap',
          },
          placeholder: {
            height: '100%',
          },
          rightContainer: {
            height: '100%',
            width: '84px',
          },
          row: {
            alignItems: 'center',
            display: 'flex',
            flexWrap: 'nowrap',
            height: '33px',
            margin: `${Layout.space.sm} 0`,
          },
          textMuted: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          },
          text: {
            margin: `0 0 0 ${Layout.space.sm}`,
            whiteSpace: 'pre',
          },
        },
      };
    },
    computed: {
      coeditedTenantUserSkills: function () {
        return getCoeditedTenantUserSkills(this.visitor.id, this.tenantUserSkills);
      },
    },
    methods: {
      isCompleted: function (tenantUserSkill) {
        return tenantUserSkill.isApproved;
      },
      isRevokable: function (tenantUserSkill) {
        return (
          !tenantUserSkill.isApproved &&
          tenantUserSkill.creater?.id === this.visitor.id
        );
      },
    },
  };
</script>
